import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN, IS_SIGNED_IN } from "constants/AuthConstant";
import AmplifyService from "services/AmplifyService";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  // token: localStorage.getItem(AUTH_TOKEN) || null,
  //   isSignedIn: localStorage.getItem(IS_SIGNED_IN) || false,
  nextStep: null,
  currentEmail: null,
};

export const signIn = createAsyncThunk(
  "auth/signIn",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
      const response = await AmplifyService.signInEmailRequest(email, password);
      console.log("signInEmailRequest response", response);
      if (response.isSignedIn) {
        // const token = response.user.refreshToken;
        // localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
        // localStorage.setItem(IS_SIGNED_IN, true);
        // return true;
        return;
      } else {
        return rejectWithValue({
          currentEmail: email,
          nextStep: response.nextStep?.signInStep,
        });
      }
    } catch (err) {
      return rejectWithValue({ message: err.message || "Error" });
    }
  }
);

export const signUp = createAsyncThunk(
  "auth/signUp",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
      const response = await AmplifyService.signUpEmailRequest(email, password);
      console.log("signUpEmailRequest response", response);
      if (response.isSignUpComplete) {
        return true;
      } else {
        return rejectWithValue({
          currentEmail: email,
          nextStep: response.nextStep?.signUpStep,
        });
      }
    } catch (err) {
      return rejectWithValue({ message: err.message || "Error" });
    }
  }
);

export const confirmSignUp = createAsyncThunk(
  "auth/confirmSignUp",
  async (data, { rejectWithValue }) => {
    const { email, code } = data;
    try {
      const response = await AmplifyService.confirmSignUpEmailRequest(
        email,
        code
      );
      console.log("confirmSignUpEmailRequest response", response);
      if (response.isSignUpComplete) {
        return true;
      } else {
        return rejectWithValue({ nextStep: response.nextStep?.signUpStep });
      }
    } catch (err) {
      return rejectWithValue({ message: err.message || "Error" });
    }
  }
);

export const resendVerificationCode = createAsyncThunk(
  "auth/resendVerificationCode",
  async (data, { rejectWithValue }) => {
    const { email, code } = data;
    try {
      const response = await AmplifyService.resendVerificationCodeRequest(
        email,
        code
      );
      console.log("response", response);
      if (response.isSignUpComplete) {
        return true;
      } else {
        return rejectWithValue({ nextStep: response.nextStep?.signInStep });
      }
    } catch (err) {
      return rejectWithValue({ message: err.message || "Error" });
    }
  }
);

export const signOut = createAsyncThunk("auth/signOut", async () => {
  const response = await AmplifyService.signOutRequest();
  //   localStorage.removeItem(AUTH_TOKEN);
  console.log("signOut response", response);
  return response.data;
});

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    const response = await AmplifyService.signInGoogleRequest();
    console.log("signInWithGoogle response", response);
    // if (response.user) {
    //   const token = response.user.refreshToken;
    //   localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
    //   return token;
    // } else {
    //   return rejectWithValue(response.message?.replace("Firebase: ", ""));
    // }
  }
);

export const signInWithFacebook = createAsyncThunk(
  "auth/signInWithFacebook",
  async (_, { rejectWithValue }) => {
    const response = await AmplifyService.signInFacebookRequest();
    console.log("signInWithFacebook response", response);
    // if (response.user) {
    //   const token = response.user.refreshToken;
    //   localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
    //   return token;
    // } else {
    //   return rejectWithValue(response.message?.replace("Firebase: ", ""));
    // }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      //   state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      //   state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      //   state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        // state.isSignedIn = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        const { currentEmail, nextStep, message } = action.payload;
        if (message) {
          state.message = message;
          state.showMessage = true;
        }
        if (nextStep) {
          state.currentEmail = currentEmail;
          state.nextStep = nextStep;
        }

        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        // state.token = null;
        state.redirect = "/auth/login";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        // state.token = null;
        // state.redirect = "/";
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.token = action.payload;
      })
      .addCase(signUp.rejected, (state, action) => {
        const { currentEmail, nextStep, message } = action.payload;
        if (message) {
          state.message = message;
          state.showMessage = true;
        }
        if (nextStep) {
          state.currentEmail = currentEmail;
          state.nextStep = nextStep;
        }
        state.loading = false;
      })
      .addCase(confirmSignUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(confirmSignUp.fulfilled, (state, action) => {
        state.loading = false;
        state.nextStep = "SIGN_IN";
        state.message = "";
        state.showMessage = false;
        // state.isSignedIn = true;
      })
      .addCase(confirmSignUp.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(resendVerificationCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(resendVerificationCode.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resendVerificationCode.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signInWithGoogle.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.token = action.payload;
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signInWithFacebook.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInWithFacebook.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.token = action.payload;
      })
      .addCase(signInWithFacebook.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
} = authSlice.actions;

export default authSlice.reducer;
